import * as types from '../actionTypes'
import UrlUtil from "../../utils/urlUtil"

const url = new UrlUtil('/api')

export const fetchUserProfile = () => {
  return async (dispatch) => {
    const axios = await import(/* webpackChunkName: "axios" */ "axios")
    const response = await axios.get(url.makeUrl(['profile', 'get']))
    if (response && response.data) {
      const userProfile = response.data
      dispatch({type: types.FETCH_USER_PROFILE_SUCCESS, payload: userProfile})
      if (userProfile) {
        if (!userProfile.enableDigitalMocDesign) {
          document.body.style.backgroundImage = "url('images/" +
              (userProfile.forCosco ? "cosco/background.png" : "oocl/background.jpg")
              + "')"
          document.body.style.backgroundSize = "cover"
        }
      }
    }
  }
}
